
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Webhooks": () => {
return Promise.all(/*  | __federation_expose_Webhooks */ [__webpack_require__.e("558"), __webpack_require__.e("849"), __webpack_require__.e("127"), __webpack_require__.e("503")]).then(() => (() => (__webpack_require__(170))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };